import { render } from "./AppCoverModal.vue?vue&type=template&id=71efd1f5&scoped=true"
import script from "./AppCoverModal.vue?vue&type=script&lang=js"
export * from "./AppCoverModal.vue?vue&type=script&lang=js"

import "./AppCoverModal.vue?vue&type=style&index=0&id=71efd1f5&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-71efd1f5"]])

export default __exports__